import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import classNames from 'classnames';
import { Typography, Theme } from '@mui/material';


interface AmountDisplayProps
    extends WithStyles<typeof styles>,
    WithTranslation {
    title: string;
    value: number;
    isAllPaid: boolean | null;
}

const styles = (theme: Theme) =>
    createStyles({
        amountValueContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            textAlign: 'end',
            minWidth: '150px',
            height: '84px',
            transition: 'all 1s ease',
        },
        amountTitle: {
            width: '490px',
            letterSpacing: '2px',
            fontSize: '1.75rem',
        },
        amountValueAllPaid: {
            transform: 'translateY(41px)',
        },
        amountValueAllPaidText: {
            color: theme.palette.primary.main,
            fontFamily: 'Montserrat',
            fontWeight: 'bold',
            fontSize: '1.75rem',
            lineHeight: '40px',
        },
        amountValue: {
            fontWeight: 'bold',
            lineHeight: '40px',
        },
    });

const AmountToDisplay: React.FC<AmountDisplayProps> = (({ title, value, isAllPaid, t, classes }) => {

    return (
        <div>
            <Typography variant="h5" className={classes.amountTitle}>
                {title}
            </Typography>
            {isAllPaid ?
                (<div
                    className={classNames(
                        classes.amountValueContainer,
                        {
                            [classes.amountValueAllPaid]: isAllPaid,
                        }
                    )}
                >
                    <span
                        className={classes.amountValueAllPaidText}
                    >
                        {t('All paid')}
                    </span>
                    <Typography variant="h4" className={classes.amountValue}>
                        {`$${value.toFixed(2)}`}
                    </Typography>
                </div>)
                : (<div
                    className={classNames(classes.amountValueContainer)}
                >
                    <Typography variant="h4" className={classes.amountValue}>
                        {`$${value.toFixed(2)}`}
                    </Typography>
                </div>)}
        </div>
    );
});

export default withTranslation()(withStyles(styles)(AmountToDisplay));